"use strict";

module.exports = {
  'name': 'acos',
  'category': 'Trigonometry',
  'syntax': ['acos(x)'],
  'description': 'Compute the inverse cosine of a value in radians.',
  'examples': ['acos(0.5)', 'acos(cos(2.3))'],
  'seealso': ['cos', 'atan', 'asin']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/acos.js
// module id = 953
// module chunks = 0